import { immerable } from "immer";
// my imports:
import * as Util from '@/app/lib/system/util';

export type LMType = 'entry' | 'given';

export default class LetterModule {
    [immerable] = true
    
    character: string = '';
    position: number;
    type: LMType = 'entry';

    constructor(
        position: number, character: string = '', 
        type: LMType = 'entry'
    ) {
        this.position = position;
        
        if (type === 'given' && !Util.isAlphaChar(character[0])) {
            console.warn("Tried to create a letter module of given type, but without an alphabetic character")
            return;
        }

        this.character = Util.firstChar(character);
        this.type = type;

        // make everything lowercase
        this.character = this.character.toLowerCase();
    }

    wipe() {
        this.character = '';
        this.type = 'entry';
    }
}